var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-cart"},[_c('cart-query',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var cart = ref.data;
return _c('div',{},[(cart)?_c('ad-shop-cart',{attrs:{"cart":cart}}):_c('div',[_vm._v(" Loading Cart... ")])],1)}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }